export function costFormat(num) {
    if (!num) return num;
    let str = typeof num === 'string' ? num : num.toFixed(2);
    let arr = str.split('.');
    let int = arr[0];
    let fract = arr[1];
    let result = '';
    let counter = 0;
    for (let i = int.length - 1; i >= 0; i--) {
        counter++;
        result = int[i] + result;
        if (counter % 3 === 0 && i !== 0) {
            result = ' ' + result;
        }
    }
    result = result + ',' + fract;
    return result;
}


// WEBPACK FOOTER //
// ./App/services/cost.js